import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';
import { ENPOINT } from './endpoint';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';


@Injectable()
export class SearchInvoicesService {

  private basePath = ENPOINT.url;
  private token = '';
  private pathsjson: Array<any> = [];
  private emailsjson: Array<any> = [];
  private pdf: Array<any> = [];
  private pdfComplemento: Array<any> = [];
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private _router: Router
  ) {
    this.token = localStorage.getItem('token');
  }


  obtenerFacturasRemision(fecha: string, folio: string, rfc: string, user): Observable<any> {
    let o = { 'fecha': fecha, 'folio': folio, 'rfc': rfc , 'userId': user};
    let json = JSON.stringify(o);
    // let obj = encodeURIComponent(json);
    //let obj = escape(json);
    
    // const options = {
    //   withCredentials: true,
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': this.token,
    //   }),
    // };
    // console.log(obj);
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('filtros', json)
    };
    return this.http.get(this.basePath + 'facturas/remision', options)
      .pipe();
  }

  obtenerFacturas(filtros, tipo): Observable<any> {
    let u = JSON.parse(localStorage.getItem('currentUser'));
    let cliente = "";
    let rfc = "";
    // console.log(filtros);
    // console.log(filtros.cliente);
    if(filtros.cliente){
      cliente = filtros.cliente;
    }else{
      cliente = u.usuario.userId;
    }

    if (filtros.tipoFactura) {
      filtros.tipoFactura = 'X';
    } else {
      filtros.tipoFactura = '';
    }
    let o = {
      'cfdi': filtros.tipoFactura,
      'cliente': cliente,
      'fechaFin': filtros.hasta,
      'fechaIni': filtros.desde,
      'userId': cliente,
      'modulo': filtros.modulo,
      'folioHigh': filtros.folio2,
      'folioLow': filtros.folio1,
      'serieHigh': filtros.serie2,
      'serieLow': filtros.serie1,
      'orden': '',
      'rfc': filtros.rfc,
      'tipoDoc': tipo
    };

    let json = JSON.stringify(o);
    // let obj = encodeURIComponent(json);
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('tipoConsulta', filtros.tipoConsulta)
        .set('filtros', json)
    };
    return this.http.get(this.basePath + 'facturas', options)
      .pipe();
  }

  enviarFacturasEmail(paths: Array<any>, emails: Array<any>, isRemision: boolean, flagXML: boolean, flagPDF: boolean, tipoConsulta): Observable<any> {
    // console.log(paths);
    this.pathsjson = [];
    this.emailsjson = [];
    this.pdf = [];
    
    paths.forEach(path => {
      if(isRemision){
        path.path_XML = path.path_XML + path.name_XML;
      }
      
      if (flagPDF) {
        if (tipoConsulta === '3') {
          let objcomplementos = {ejercicio: path.ejercicio, folioSAP: path.id_DOC, sociedad: path.sociedad};
          this.pdfComplemento.push(objcomplementos);
        } else {
          let objpdf = {cliente: path.cliente, serie: path.serie, folio: path.folio, fecha: path.fecha};
          this.pdf.push(objpdf);
        }
      }
      
      if (path.path_XML !== '' && flagXML) {
        this.pathsjson.push({ 'path': path.path_XML });
      }
      if (path.path_PDF !== '' && flagPDF) {
        this.pathsjson.push({ 'path': path.path_PDF });
      }
    });
    emails.forEach(email => {
      this.emailsjson.push({ 'email': email.trim() });
    });

    let jsonPDF = JSON.stringify(this.pdf);
    let jsonPDFComplemento = JSON.stringify(this.pdfComplemento);
    let jsonPaths = JSON.stringify(this.pathsjson);
    let jsonEmails = JSON.stringify(this.emailsjson);    
    const httpHeaders = new HttpHeaders({
          'Content-Type': 'multipart/form-data'});
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    
    if (tipoConsulta === '3') {
      this.pdfComplemento = [];
      this.pdf = [];
      let formData = new FormData();
      formData.append('email', jsonEmails);
      formData.append('rutas', jsonPaths);
      formData.append('pdf', jsonPDF);
      formData.append('complementos', jsonPDFComplemento);
      
      return this.http.post(this.basePath + 'facturas/envio', formData, options)
      .pipe();
    } else {
      this.pdfComplemento = [];
      this.pdf = [];
      let formData = new FormData();
      formData.append('email', jsonEmails);
      formData.append('rutas', jsonPaths);
      formData.append('pdf', jsonPDF);

      return this.http.post(this.basePath + 'facturas/envio', formData, options);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search-invoices.service.ts